import {Component} from "@angular/core";
import {Employee} from "../../../../../../../server/src/base/entities/employee/Employee";

/**
 * Created by Benoit Valkenberg on 16-12-17.
 */
@Component({
    selector: 'trips-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class TripsPresentationComponent {

    public employee:Employee;

    ngOnInit(){
        this.employee = this.CreateLucienne();
    }

    private CreateLucienne(): Employee{
        let people = new Employee();
        people.name = "Lucienne Schiltz-Friederes";
        people.picture = "https://schiltz-people-pictures.s3-eu-west-1.amazonaws.com/Lucienne.jpg";
        people.job = "";
        return people;
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/presentation/presentation.ts